import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const now = dayjs();

export default function ItemDate({ date }) {
    const d = dayjs(date);
    if (now.diff(d, 'd') < 1) {
        return <div className="ItemDate text-[#06b600] font-medium">Just Now</div>;
    }
    return <div className="ItemDate">{now.from(d)}</div>;
}
